export enum LocaleEnum {
  EN = 'en',
  TR = 'tr',
  DE = 'de',
  ES = 'es',
  PL = 'pl',
  FR = 'fr',
  IT = 'it',
  EL = 'el',
  BG = 'bg',
  RO = 'ro',
  HU = 'hu',
  CN = 'cn',
  HI = 'hi',
  CS = 'cs',
  HR = 'hr',
  LT = 'lt',
  LV = 'lv',
  SK = 'sk',
  SL = 'sl',
  KN = 'kn',
}
